(function (window) {
  'use strict';

  const redirectCheckboxes = document.querySelectorAll('.js-form-item-redirect');

  function redirectPage(e) {
    const redirectUrl = e.target.closest('.js-form-item-redirect').getAttribute('data-redirect-url');
    if (redirectUrl) {
      window.location.href = redirectUrl;
    }
  }

  function init() {
    for (let i = 0; i < redirectCheckboxes.length; i++) {
      redirectCheckboxes[i].addEventListener('click', redirectPage);
    }
  }

  init();
})(this);
